import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3824b22e"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onClick"];
const _hoisted_2 = { class: "descript" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "btn" }, "完成作业", -1));
import { ref } from 'vue';
import { hostPath } from '@/public/utils/basePath';
import { jumpModuleApp, appPort } from '@/widget/index';
export default /*#__PURE__*/ _defineComponent({
    props: {
        item: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    setup(__props) {
        const props = __props;
        const detail = ref(props.item.detail);
        const toDetail = () => {
            let { taskId } = props.item;
            let { homeworkId } = detail.value;
            let url = `${hostPath}/doctor/work/detail?questionId=${homeworkId}&taskId=${taskId}`;
            if (appPort()) {
                jumpModuleApp({
                    typeId: 'home_work_detail_web',
                    full_screen: true,
                    url
                });
            }
            else {
                location.href = url;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "homeworkWrapper",
                onClick: _withModifiers(toDetail, ["stop"])
            }, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(detail.value.description), 1),
                _hoisted_3
            ], 8, _hoisted_1));
        };
    }
});
